let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yryI"), load("7Creg"), load("9dfGK")]).then(() => parcelRequire('79XtQ'));